import moment from "moment-timezone";

export const MOVE_IN_CONDITION_SUBMISSION_WINDOW_DAYS = 2;

const STATE_TIME_ZONES: Record<string, string> = {
  AL: "America/Chicago",
  ALABAMA: "America/Chicago",
  CO: "America/Denver",
  COLORADO: "America/Denver",
  TX: "America/Chicago",
  TEXAS: "America/Chicago",
  FL: "America/New_York",
  FLORIDA: "America/New_York",
  SC: "America/New_York",
  "SOUTH CAROLINA": "America/New_York",
  OH: "America/New_York",
  OHIO: "America/New_York",
  AZ: "America/Phoenix",
  ARIZONA: "America/Phoenix",
};

const stateTimeZone = (state?: string | null) =>
  STATE_TIME_ZONES[state?.trim().toUpperCase() ?? ""] ?? "America/Chicago";

const dateOnly = (value?: string | Date | null) => {
  if (!value) return "";

  if (typeof value === "string") {
    const isoDate = value.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
    if (isoDate) return isoDate;
  }

  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

export const formatMoveInDate = (value?: string | Date | null) => {
  const normalizedDate = dateOnly(value);
  return normalizedDate
    ? moment.utc(normalizedDate, "YYYY-MM-DD").format("MM/DD/YYYY")
    : "Not available";
};

export const getMoveInConditionAvailability = (
  moveInDate?: string | Date | null,
  state?: string | null
) => {
  const moveInDateOnly = dateOnly(moveInDate);
  if (!moveInDateOnly) {
    return {
      dueDateLabel: "",
      isAvailable: false,
      message: "Move-in date is not available for this lease.",
      moveInDateLabel: "",
    };
  }

  const timezone = stateTimeZone(state);
  const moveInDay = moment
    .tz(moveInDateOnly, "YYYY-MM-DD", timezone)
    .startOf("day");
  const dueDay = moveInDay
    .clone()
    .add(MOVE_IN_CONDITION_SUBMISSION_WINDOW_DAYS, "days");
  const today = moment.tz(timezone).startOf("day");

  const moveInDateLabel = moveInDay.format("MM/DD/YYYY");
  const dueDateLabel = dueDay.format("MM/DD/YYYY");

  if (today.isBefore(moveInDay, "day")) {
    return {
      dueDateLabel,
      isAvailable: false,
      message: `This form can be submitted starting ${moveInDateLabel}.`,
      moveInDateLabel,
    };
  }

  if (today.isAfter(dueDay, "day")) {
    return {
      dueDateLabel,
      isAvailable: false,
      message: `This form was due by ${dueDateLabel}.`,
      moveInDateLabel,
    };
  }

  return {
    dueDateLabel,
    isAvailable: true,
    message: `This form can be submitted through ${dueDateLabel}.`,
    moveInDateLabel,
  };
};
